import * as stylex from '@stylexjs/stylex'

import SearchInput from './SearchInput'
import SegmentedControl from './SegmentedControl'

export type ActivityKindFilter = 'all' | 'expense' | 'settlement'

const styles = stylex.create({
  toolbar: { display: 'flex', flexDirection: 'column', gap: '10px', '@media (min-width: 640px)': { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' } },
  search: { minWidth: 0, flex: '1 1 0%' },
  filters: { minWidth: '260px' },
})

type Props = {
  kind: ActivityKindFilter
  onKindChange: (kind: ActivityKindFilter) => void
  onQueryChange: (query: string) => void
  placeholder?: string
  query: string
}

export default function ActivityToolbar({ kind, onKindChange, onQueryChange, placeholder = 'Search expenses, people, or groups', query }: Props) {
  return <div {...stylex.props(styles.toolbar)}>
    <SearchInput aria-label="Search activity" {...stylex.props(styles.search)} onChange={(event) => onQueryChange(event.target.value)} placeholder={placeholder} value={query} />
    <div {...stylex.props(styles.filters)}><SegmentedControl onChange={onKindChange} options={[{ label: 'All', value: 'all' }, { label: 'Expenses', value: 'expense' }, { label: 'Payments', value: 'settlement' }]} value={kind} /></div>
  </div>
}
